<script lang="ts">
  export let width = 64;
  export let height = 64;
</script>

<style>
  @keyframes rotate {
    from {
      transform: rotateY(0deg);
    }
    to {
      transform: rotateY(360deg);
    }
  }
  .spinner {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
    left: calc(50% - 32px);

    @keyframes rotate {
      from {
        transform: rotateY(0deg);
      }
      to {
        transform: rotateY(360deg);
      }
    }
  }

  .spinner svg {
    transform-style: preserve-3d;
  }

  .spinner svg path {
    transform-style: preserve-3d;
    transform-origin: center center;
    animation-name: rotate;
    animation-duration: 3s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<div class="spinner">
  <svg
    {width}
    {height}
    viewBox="0 0 858 861"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M280.775 511.708H353.522V600.959C353.522 600.959 368.312 618.135 428.292 618.176H428.507C488.501 618.135 503.278 600.959 503.278 600.959V511.708H576.031C590.996 446.295 563.09 389.488 563.09 389.488H293.71C293.71 389.488 265.804 446.295 280.775 511.708Z"
      fill="#030304"
    />
    <path
      d="M457.146 860L462.074 806.89C462.077 806.657 462.157 806.431 462.302 806.247C462.447 806.064 462.648 805.933 462.874 805.875C463.102 805.84 463.334 805.876 463.541 805.977C463.747 806.078 463.918 806.239 464.031 806.44L496.582 859.469C496.675 859.622 496.805 859.75 496.96 859.841C497.115 859.931 497.29 859.981 497.469 859.987H608.045C608.045 859.987 608.65 859.987 608.832 859.516C608.911 859.375 608.961 859.22 608.977 859.059C608.993 858.898 608.976 858.735 608.926 858.582L552.643 747.233C552.496 747.02 552.417 746.768 552.417 746.51C552.417 746.252 552.496 746 552.643 745.787C552.791 745.599 553.004 745.472 553.24 745.432C553.476 745.393 553.719 745.442 553.92 745.572C553.92 745.572 578.122 759.166 585.961 762.567C585.961 762.567 603.655 770.581 614.035 771.152C614.035 771.152 626.627 772.302 643.333 763.549C643.333 763.549 692.947 736.597 717.632 720.846L719.501 719.629L658.089 667.723H717.317C717.317 667.723 744.833 668.543 762.903 653.276C762.903 653.276 787.993 633.276 821.976 586.431L723.461 549.396C723.461 549.396 755.488 547.877 763.717 546.835C763.717 546.835 795.442 545.066 810.682 522.565C810.682 522.565 827.771 495.795 857.176 416.44C857.176 416.44 786.48 421.59 745.868 422.551C745.868 422.551 783.388 398.215 799.361 385.119C799.361 385.119 816.302 371.331 818.386 351.048C818.386 351.048 826.326 281.058 827.348 214.973L690.5 307.572C690.5 307.572 718.258 272.453 733.525 244.862C733.525 244.862 756.241 210.22 736.382 160.324C736.382 160.324 728.443 134.172 690.52 70.3669L622.17 185.917C622.17 185.917 661.309 81.5805 627.904 50.4811C627.904 50.4811 601.235 23.2069 538.848 0L509.194 296.58C509.194 296.58 511.392 297.528 515.157 299.545C577.241 331.142 619.776 395.586 619.776 470.007C619.776 575.366 534.512 660.812 429.213 661.108H427.963C322.692 660.846 237.4 575.366 237.4 470.007C237.4 395.586 279.935 331.115 342.019 299.545C345.784 297.528 347.983 296.58 347.983 296.58L318.329 0C255.942 23.2069 229.245 50.4811 229.245 50.4811C195.84 81.5805 234.98 185.917 234.98 185.917L166.677 70.3669C128.754 134.172 120.814 160.324 120.814 160.324C100.955 210.22 123.698 244.862 123.698 244.862C138.952 272.426 166.724 307.572 166.724 307.572L29.8288 214.987C30.8507 281.071 38.7902 351.062 38.7902 351.062C40.8743 371.344 57.8156 385.132 57.8156 385.132C73.7888 398.228 111.308 422.565 111.308 422.565C70.6964 421.603 0 416.454 0 416.454C29.4053 495.782 46.4945 522.579 46.4945 522.579C61.7349 545.08 93.4461 546.848 93.4461 546.848C101.675 547.89 133.702 549.409 133.702 549.409L35.2003 586.445C69.1837 633.289 94.273 653.289 94.273 653.289C112.344 668.557 139.833 667.736 139.833 667.736H199.054L137.641 719.643L139.51 720.859C164.196 736.611 213.81 763.562 213.81 763.562C230.516 772.302 243.108 771.166 243.108 771.166C253.488 770.594 271.182 762.581 271.182 762.581C278.987 759.179 303.223 745.586 303.223 745.586C303.424 745.456 303.667 745.406 303.903 745.446C304.139 745.486 304.352 745.612 304.5 745.801C304.647 746.013 304.725 746.265 304.725 746.523C304.725 746.782 304.647 747.034 304.5 747.246L248.217 858.595C248.167 858.749 248.149 858.911 248.166 859.072C248.182 859.233 248.231 859.389 248.311 859.529C248.493 859.973 249.098 860 249.098 860H359.707C359.886 859.995 360.062 859.944 360.217 859.854C360.372 859.764 360.501 859.636 360.594 859.482L393.146 806.453C393.258 806.253 393.429 806.091 393.636 805.99C393.842 805.889 394.075 805.854 394.302 805.889C394.529 805.946 394.73 806.077 394.874 806.261C395.019 806.444 395.099 806.67 395.102 806.904L400.023 860.013L457.146 860Z"
      fill="#030304"
    />
  </svg>
</div>
